import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import {useSelector} from "react-redux/es/exports";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import AddButton from "../../../components/AddButton";
import Pagination from "../../../components/Pagination";
import Select from "../../../components/Select";
import EditButton from "../../../components/EditButton";
import DeleteButton from "../../../components/DeleteButton";
import Loading from "../../../components/loading";
import {toast} from "react-toastify";
import CopyButton from "../../../components/CopyButton";
import PriceButton from "../../../components/PriceButton";
import {action, getList} from "../../../services/service";
import fetchData from "../../../fetch/fetchData";
import ComboboxComponent from "../../../components/Combobox";
import {FcFilledFilter} from "@react-icons/all-files/fc/FcFilledFilter";
import {FcClearFilters} from "@react-icons/all-files/fc/FcClearFilters";
import TempDataTable from "../../../components/TemDataTable";
import {deleteFilling} from "../../../services/fillingService";
import {AiOutlineDollarCircle, AiOutlineFileExcel, AiOutlineUpload, AiOutlineTranslation, AiOutlineWarning} from "react-icons/ai";
import Dropdown from "../../../components/dropdown/dropdown";
import {postData} from "../../../services/api.service";
import axios from "axios";
import {b64toBlob} from "../../../utils/utils";
import {useErrorBoundary} from "react-error-boundary";
import {FaProductHunt} from "react-icons/fa";
import UploadModal from "../../../components/uploadModal/uploadModal";
import NewPriceLayout from "../NewPriceLayoutV2";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "name", sort: true
}, {
    name: "directory_name", sort: true
}, {
    name: "article", sort: true
}, {
    name: "type", sort: false
}, {
    name: "supplier", sort: true
}, {
    name: "unit", sort: false
}, <span className="sr-only">Edit</span>,];

const bodyTable = ["id", "name", "nameInCatalog", "article", "profileType", "supplierName", "unitName", "actions",];
const dropdownItems = [
    {
        icon: FaProductHunt,
        name: "Product"
    },
    {
        icon: AiOutlineDollarCircle,
        name: "Price"
    },
    {
        icon: AiOutlineTranslation,
        name: "Translation"
    },
]
function SealType({t}) {
    const {showBoundary} = useErrorBoundary()
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [itemOffset, setItemOffset] = useState(localStorage.getItem("seitemOffset") ? parseInt(localStorage.getItem("seitemOffset")) : null);
    const [forcePage, setForcePage] = useState(localStorage.getItem("seforcePage") ? parseInt(localStorage.getItem("seforcePage")) : 0);
    const [data, setData] = useState({
        data: [], recordsTotal: 0, pageCount: 0,
    });
    const [isLoading, setIsLoading] = useState(true);
    const {token} = useSelector((state) => state.user);
    const navigate = useNavigate();

    const [suppliers, setSuppliers] = useState([]);
    const [types, setTypes] = useState([]);
    const [profileSystems, setProfileSystems] = useState([]);
    const [supplierId, setSupplierId] = useState(localStorage.getItem("seSupplierId") ? parseInt(localStorage.getItem("seSupplierId")) : null);
    const [profileSystemId, setProfileSystemId] = useState(localStorage.getItem("seProfileSystemId") ? parseInt(localStorage.getItem("seProfileSystemId")) : null);
    const [searchTxt, setSearchTxt] = useState(localStorage.getItem("seSearchTxt") || null);
    const [type, setType] = useState(localStorage.getItem("seType") || null);
    const [hasPriceWarning, setHasPriceWarning] = useState(localStorage.getItem("seHasPriceWarning") === "true" ? true : null);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState("");
    const [loaded, setLoaded] = useState(0);
    const [uploadName,setUploadName] = useState("")
    const oldSelectedId = localStorage.getItem("seselectedId") ? parseInt(localStorage.getItem("seselectedId")) : null
    const [selectedId, setSelectedId] = useState(oldSelectedId);
    useEffect(() => {
        localStorage.setItem("seitemOffset", JSON.stringify(itemOffset));
        localStorage.setItem('seselectedId', JSON.stringify(selectedId));
        localStorage.setItem('seforcePage', forcePage.toString());
        if (searchTxt) localStorage.setItem("seSearchTxt", searchTxt); else localStorage.removeItem("seSearchTxt");
        if (supplierId) localStorage.setItem("seSupplierId", supplierId); else localStorage.removeItem("seSupplierId");
        if (profileSystemId) localStorage.setItem("seProfileSystemId", profileSystemId); else localStorage.removeItem("seProfileSystemId");
        if (type) localStorage.setItem("seType", type); else localStorage.removeItem("seType");
        if (hasPriceWarning) localStorage.setItem("seHasPriceWarning", "true"); else localStorage.removeItem("seHasPriceWarning");
    }, [selectedId, itemOffset, searchTxt, supplierId, profileSystemId, type, hasPriceWarning]);
    const [showPriceLayout, setShowPriceLayout] = useState(false);
    const onDeleteItem = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            const response = await deleteFilling(`${process.env.REACT_APP_HOST_BASE_URL}/v1/product/${id}`, token);
            if (response.success) {
                fetchDataSeal();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                setIsLoading(false);
                if (response.status === 420) {
                    toast.warn(response.body.error, {
                        position: "bottom-right",
                        autoClose: 10000,
                        closeOnClick: true,
                        className: "product-background",
                        pauseOnHover: true,
                    });
                } else {
                    navigate("/error", {
                        state: {
                            status: response.status, message: response.body ? response.body.error : "Error",
                        },
                    });
                }
            }
        } else {
            return;
        }
    };

    const fetchDataSupplierList = async () => {
        const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/supplier/list`, token);
        if (response.success) {
            setSuppliers(response.data);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchProfileSystemList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/list`, token);
        if (response.success) {
            setProfileSystems(response.data.map((item)=>{
                return {
                    ...item,
                    name: item.name + ' - ' + item.parentName,
                }
            }));
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataTypesList = async (type) => {
        const response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/product/enum/article/type/${type}`, token);
        if (response.success) {
            setTypes(response.data.map((item) => {
                return {
                    id: item.id,
                    name: t(`${item.name}`),
                    value: item.name,
                };
            }));
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataSeal = async () => {
        const response = await fetchData(`v1/product/table`, token, {
            id: null,
            draw: 1,
            start: itemOffset,
            length: itemsPerPage,
            recordsTotal: 0,
            columns: [],
            order: [{column: sortColumn, dir: sortDir}],
            search: {value: "", regex: true},
            filter: {
                searchTxt: searchTxt,
                groupType: "SEAL",
                type: type,
                supplierId: supplierId,
                productSeriesId: null,
                profileSystemId: profileSystemId,
                hasPriceWarning: hasPriceWarning,
            }
        });
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: item.id,
                    name: (
                        <span className="flex items-center gap-1">
                            {item.name}
                            {item.hasPriceWarning && (
                                <AiOutlineWarning className="text-yellow-500 w-4 h-4 flex-shrink-0" title="Price warning" />
                            )}
                        </span>
                    ),
                    nameInCatalog: item.nameInCatalog,
                    article: item.article,
                    profileType: t(`${item.profileType}`),
                    supplierName: item.supplierName,
                    unitName: item.unitName,
                    actions: (<div className="flex">
                        <CopyButton onclick={() => onCopyRow(item.id)}/>
                        <EditButton onclick={() => navigate(`/product/seal/update/${item.id}`)}/>
                        <DeleteButton onclick={() => onDeleteItem(item.id)}/>
                    </div>),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(response.data.recordsFiltered / parseInt(itemsPerPage)),
            });
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchDataSeal();
        }
    }, [clear]);

    useEffect(() => {
        fetchDataSupplierList();
        fetchDataTypesList("SEAL");
        fetchProfileSystemList();
        // if (isLoading)
            fetchDataSeal();
    }, [itemOffset, itemsPerPage]);

    const onCopyRow = async (id) => {
        let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/copy/${id}`;
        let res = await action(url, "POST", token);
        if (res.success) {
            navigate(`/product/seal/update/${res.data.id}`)
        } else {
            console.log(res.message);
        }
    };

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset = (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
        localStorage.setItem("seitemOffset",itemOffset)
        setIsLoading(true);
    };

    const onClickFilter = () => {
        setItemOffset(0);
        localStorage.setItem("seitemOffset",itemOffset)
        fetchDataSeal();
    }


    const onClickClearFilter = () => {
        setItemOffset(0);
        setSelectedId(0);
        setForcePage(0);
        // localStorage.setItem("itemOffset",itemOffset)
        setType(null)
        setSearchTxt(null);
        setSupplierId(null);
        setProfileSystemId(null);
        setHasPriceWarning(null);
        setClear(true);
    }

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    const exportHandler = async (name) => {
        let url = name === "Product" ? 'v1/product/excel/information' : 'v1/product/excel/price';
        try {
            const response = await postData(
                `${process.env.REACT_APP_HOST_BASE_URL}/${url}`,
                {
                    filter: {
                        searchTxt: searchTxt,
                        groupType: "SEAL",
                        type: type,
                        supplierId: supplierId,
                        productSeriesId: null,
                        profileSystemId: profileSystemId,
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    responseType: "blob",
                }
            );
            if (response.status === 200) {
                const url = URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = url;
                link.download = "excel-file.xlsx";
                link.click();
                URL.revokeObjectURL(url);
            } else {
                showBoundary(response);
            }
        } catch (error) {
            showBoundary(error);
        }
    }
    const closeModalHandler = ()=>{
        setOpenModal(false)
    }
    const uploadHandler = (name)=>{
        setUploadName(name);
        setOpenModal(true)
    }

    const fileChangeHandler = (e) => {
        setFileName(e.target.files[0].name);
        setFile(e.target.files[0]);
    };

    const getTemplateDownload = async ()=>{
        try{
            let url;
            if(uploadName === "Product"){
                url = "v1/product/excel/seal/example"
            } else if(uploadName === "Price"){
                url = "v1/product/excel/example"
            } else if(uploadName === "Translation"){
                url = "v1/product/translation/excel/example"
            }else{
                return;
            }
            const response = await axios.get(`${process.env.REACT_APP_HOST_BASE_URL}/${url}`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            });
            if(response.status !== 200){
                showBoundary(response)
            }else{
                const url = URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = url;
                link.download = "excel-file.xlsx";
                link.click();
                URL.revokeObjectURL(url);
            }
        }catch (error){
            showBoundary(error)
        }
    }


    const handleSubmit = async (e) => {
        try{
            e.preventDefault();
            let url;
            if(uploadName === "Product"){
                url = "v1/product/seal/upload"
            } else if(uploadName === "Price"){
                url = "v1/product/price/upload"
            } else if(uploadName === "Translation"){
                url = "v1/product/translation/upload"
            }else{
                return;
            }
            const formData = new FormData();
            formData.append("file", file);
            const response = await axios.post(
                `${process.env.REACT_APP_HOST_BASE_URL}/${url}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    onUploadProgress: ({loaded, total}) => {
                        let indexOfLoaded = Math.floor((loaded / total) * 100);
                        setLoaded(indexOfLoaded);
                    },
                }
            );
            if (response.status !== 200) {
                showBoundary(response)
            } else {
                if (response.data.isEmpty) {
                    setOpenModal(false);
                    setFile("");
                    setLoaded(0);
                    setFileName("");
                    if(uploadName === "Product"){
                        fetchDataSeal()
                    }
                }else{
                    const blob = b64toBlob(response.data.base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "failed-product.xlsx";
                    link.click();
                    URL.revokeObjectURL(url);
                    setOpenModal(false);
                    setFile("");
                    setLoaded(0);
                    setFileName("");
                }
            }
        }catch (error){
            showBoundary(error)
        }
    };

    return (<>
        {isLoading && <Loading/>}
        <UploadModal
            openModal={openModal}
            closeModalHandler={closeModalHandler}
            handleSubmit={handleSubmit}
            fileName={fileName}
            fileChangeHandler={fileChangeHandler}
            getTemplateDownload={getTemplateDownload}
            loaded={loaded}
        />
        <div className="px-4 py-4 mt-5 sm:px-6 lg:px-8">
            <div>
                <p className="font-bold text-2xl">{t('sidebar_menu_seal')}</p>
            </div>
            <div className="w-full grid grid-cols-7 gap-3 mb-5">
                <div className="">
                    <label
                        htmlFor="article"
                        className="block text-sm font-medium text-gray-700"
                    >
                        {t('name') + " | " + t('article')}
                    </label>
                    <input
                        placeholder={t('name') + " .... " + t('article')}
                        type="text"
                        className="mt-3 w-full block rounded-md border-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        defaultValue={searchTxt ? searchTxt : ""}
                        onChange={(e) => {
                            e.preventDefault();
                            setSearchTxt(e.target.value);
                        }}
                    />
                </div>
                <div className="">
                    <ComboboxComponent
                        data={suppliers}
                        label={t(`supplier`)}
                        item={supplierId ? suppliers.find((item) => item.id === supplierId) : null}
                        onChange={(value) => {
                            setSupplierId(value.id)
                        }}
                    />
                </div>
                <div className="">
                    <ComboboxComponent
                        data={types}
                        label={t(`type`)}
                        item={type ? types.find((item) => item.value === type) : null}
                        onChange={(value) => {
                            setType(value.value)
                        }}
                    />
                </div>
                <div className="">
                    <ComboboxComponent
                        data={profileSystems}
                        label={t(`sidebar_menu_profile_system`)}
                        item={profileSystemId ? profileSystems.find((item) => item.id === profileSystemId) : null}
                        onChange={(value) => {
                            setProfileSystemId(value.id);
                        }}
                    />
                </div>
                <div className="flex items-end pb-1">
                    <label className="flex items-center gap-2 cursor-pointer select-none text-sm font-medium text-gray-700">
                        <input
                            type="checkbox"
                            checked={hasPriceWarning === true}
                            onChange={(e) => setHasPriceWarning(e.target.checked ? true : null)}
                            className="w-4 h-4 text-yellow-500 border-gray-300 rounded"
                        />
                        <AiOutlineWarning className="text-yellow-500 w-4 h-4" />
                        {t("price_warning")}
                    </label>
                </div>
                <div className=" flex items-end space-x-3">
                    <button
                        onClick={onClickFilter}
                        type="button"
                        className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-3 py-1.5 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                        <FcFilledFilter className="-ml-0.5 mr-2 h-5 w-5" aria-hidden="true"/>
                        {t('action.filter')}
                    </button>
                    <button
                        onClick={onClickClearFilter}
                        type="button"
                        className="inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-3 py-1.5 text-sm font-medium leading-4 text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
                    >
                        <FcClearFilters className="-ml-0.5 mr-2 h-5 w-5" aria-hidden="true"/>
                        {t('action.clear')}
                    </button>

                    <Dropdown
                        dropdownName={{
                            icon: AiOutlineUpload,
                            name: "Upload"
                        }}
                        dropdownItems={dropdownItems}
                        className={"bg-amber-500 ring-amber-500"}
                        dropownHandler={uploadHandler}
                    />

                    <Dropdown
                        dropdownName={{
                            icon: AiOutlineFileExcel,
                            name: "Export"
                        }}
                        className={"bg-green-500 ring-green-500"}
                        dropdownItems={dropdownItems}
                        dropownHandler={exportHandler}
                    />
                </div>
            </div>
            <div>
                <div className="flex justify-between items-center mb-4">
                    <Select
                        setItemsPerPage={setItemsPerPage}
                        itemsPerPage={itemsPerPage}
                    />
                    <AddButton title={t(`add_seal`)} url={"add"}/>
                </div>
                <TempDataTable
                    data={data.data}
                    headerTable={headerTable}
                    bodyContent={bodyTable}
                    sortFunction={sortFunction}
                    selectedRowId={selectedId}
                    rowHandler={(id) => {
                        setSelectedId(id);
                        setShowPriceLayout(true);
                    }}
                />
                {data?.pageCount !== 0 && (
                    <Pagination
                        handlePageClick={handlePageClick}
                        pageCount={data.pageCount}
                        forcePage={forcePage}
                    />
                )}
            </div>
            {
                selectedId && showPriceLayout && (
                    <div className="px-4 py-4 sm:px-6 lg:px-8">
                        <NewPriceLayout
                            selectedId={selectedId}
                            groupType={"SEAL"}
                        />
                    </div>
                )
            }
        </div>
    </>);
}

export default withTranslation()(SealType);
